import BVASelect from "../../../components/BVASelect/BVASelect";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import HDEAnalysis from "./HDEAnalysis"
import SDEAnalysis from "./SDEAnalysis";
import { updateHDEAnalysis, updateSDEAnalysis } from "../../../store/modules/qualityOfEarnings/actions";

const HDE_ANALYSIS_SECTION = "HDE_ANALYSIS_SECTION"
const SDE_ANALYSIS_SECTION = "SDE_ANALYSIS_SECTION"
const AUTO = "AUTO"
const MANUAL = "MANUAL"

const selectSections = [
  { label: "Discretionary Earnings Survey", value: HDE_ANALYSIS_SECTION },
  { label: "Discretionary Earnings Report", value: SDE_ANALYSIS_SECTION },
]

const independence = [
  { label: "Consolidated Mode", value: AUTO },
  { label: "Independent Mode", value: MANUAL }
]

function QualityOfEarnings({ companyManuality, currentCompanyHDEAnalysis, dispatchUpdateIndependence }) {
  // States
  const [selectedSection, setSelectedSection] = useState(HDE_ANALYSIS_SECTION);
  const [selectedIndependence, setSelectedIndependence] = useState(currentCompanyHDEAnalysis?.independence || AUTO);
  
  const handleIndependenceOnChange = (independence) => {
    dispatchUpdateIndependence(independence);
    setSelectedIndependence(independence);
  };

  useEffect(() => {
    companyManuality && handleIndependenceOnChange(MANUAL);   //because the standard generation is AUTO
  }, []);
  
  // Methods
  const getSection = () => {
    switch(selectedSection) {
      case HDE_ANALYSIS_SECTION:
        return <HDEAnalysis />

      case SDE_ANALYSIS_SECTION:
        return <SDEAnalysis />

      default:
        break
    }
  }

  return (
    <div>
      <div className="flex items-center">
        <BVASelect
          items={selectSections}
          value={selectedSection}
          width="24em"
          placeholder="Select a section"
          onChange={(value) => setSelectedSection(value)}
        />
        {!companyManuality && <div className="ml-4">
          <BVASelect
            items={independence}
            value={selectedIndependence}
            width="10em"
            placeholder="Select data independence"
            onChange={(value) => handleIndependenceOnChange(value)}
          />
        </div>}
      </div>
      <div className="mt-20">
        {getSection()}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  currentCompanyHDEAnalysis: state.qualityOfEarnings.currentCompanyHDEAnalysis,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchUpdateIndependence(independence) {
    await dispatch(updateHDEAnalysis("MANUAL", independence, 0, "independence", 0));
    await dispatch(updateSDEAnalysis("MANUAL", independence, 0, "independence", 0));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(QualityOfEarnings);
